<template>
	<div
		class="ao-groupbox pa-3"
		:class="customClass"
	>
		<slot />
	</div>
</template>

<script>
export default {
	name: 'AoGroupbox',
	props: {
		custom: {
			type: String, // softDelete, hardDelete, navigationLink, tabLink
			default: null,
			// TODO: add validation
		},
	},
	computed: {
		customClass() {
			let prefix = 'ao-custom-groupBox-'
			let customClass = ''
			if (this.custom) {
				customClass = prefix + this.custom
			}
			return customClass
		},
	},
}
</script>

<style lang="scss">
.ao-groupbox {
	background: #f6f8f9;
	border: 1px solid #e6eef3;
	border-radius: 4px;
	width: 100%;
}
.ao-custom-groupBox-preview {
	background: #f6f8f9;
	border: none;
}
.ao-custom-groupBox-card {
	background: white;
}
</style>
